module.exports = __webpack_public_path__ + "assets/img/face_check_scene3.47645167.png";